module.exports = __webpack_public_path__ + "media/assets/site_images/greenery-c701757ae477ab78349abf950d08ac58.jpg";